/* eslint-disable import/prefer-default-export */

import merge from 'lodash/merge';

import { variant1, variant2, variant3, variant4, variant5 } from './constants';

export const useConfiguration = appNameConfig => {
  const { variant } = appNameConfig;

  const socialImagesMaxHeight = '24px';
  const socialImagesMaxWidth = '24px';
  let footerFontFamily = 'default';
  let footerFontFamilyBold = 'bold';
  let bottomContainerPaddingBottom = ['default', 'default', 'l'];
  let bottomContainerPaddingTop = ['default', 'default', 'l'];
  let bottomLinksFontFamily = 'bold';
  let bottomLinksFontSize = '12px';
  let bottomLinksLineHeight = '22px';
  let bottomLinksMarginX = ['0', 's', 's'];
  let bottomMenuGap = 'xs';
  let bottomMenuListDisplay = ['block', 'flex', 'flex'];
  let bottomMenuReversed;
  let copyRightLineHeight;
  let footerWidth = 1280;
  let footerWidthPx = `${footerWidth}px`;
  let footerPaddingTop = 'l';
  let footerColumnsGap = 'm';
  let footerColumnListMarginBottom = 'm';
  let footerLocationMarginLeft;
  let addressMarginRight = ['xs', 'xs', 'default'];
  let addressLineHeight;
  let footerMobileContainerPaddingX = '20px';
  let footerMobileContainerPaddingTop = 'default';
  let footerBottomLinksListItemPaddingY = ['s', '0'];
  let footerSecondaryMenuContainerPaddingX = 'zero';
  let highlightLangColor = 'typographyDefault';
  let highlightLangFont = 'default';
  let languageAtSecondary;
  let languageShowLangCode;
  let listHeaderLineHeight = '24px';
  let languageLinkFontSize;
  let languageLinkLineHeight = '18px';
  let locationAtSecondary;
  let locationAtTop = true;
  let logoAtMain;
  // Item link styles
  let itemLinkLineHeight = '24px';
  let itemLinkFontSize;
  let locationLabelFontSize = '14px';
  let locationLabelLineHeight = '24px';
  let mainContainerPaddingBottom = [0, 0, 'l'];
  let mainContainerPaddingTop = [0, 0, 'l'];
  let mobileBottomLinksAlignment = 'center';
  let mobileContainerStyle = theme => ({ borderTop: `${theme.borders[1]} ${theme.colors.grey[3]}` });
  let mobileLanguageAtSecondary;
  let mobileLocationAtSecondary;
  let mobileLocationAtSecondaryUnder;
  let mobileLocationAtTop = true;
  let mobileLocationNoMargin;
  let mobileLocationTwoLines;
  let mobileMainAccordionBorder = '1px solid';
  let mobileMainAccordionBorderColor = 'grey.3';
  let mobileMainAccordionHeight = '45px';
  let mobileMainAccordionIconName = 'animatedPlusMinus';
  let desktopMainBorder = '2px solid';
  let desktopMainBorderColor = 'black';
  let mobileSecondaryBorder = '1px solid';
  let mobileSecondaryBorderColor = 'black';
  let mobileSocialAtSecondary;
  let mobileSocialAtTop = true;
  let numberOfFooterColumn;
  let secondaryContainerPaddingY = 'l';
  let socialMenuAtMain = true;
  let socialMenuAtSecondary;
  let socialMediaLinksGapDesktop;
  let topContainerBorderBottom = '2px solid';
  let topContainerBorderBottomColor = ['grey.2', 'grey.2', 'black'];
  let topContainerPaddingB = 'l';
  let userLocationContainerMinHeight = ['42px', '42px', '50px'];
  let userLocationContainerPaddingBottom = ['s', 's', 0];
  let userLocationContainerWidth = ['unset', 'unset', '40%'];
  let maxSocialMediaIcons;
  let hideMapMarkerIconWhenNoAddressSelected = false;
  let locationLabelMarginBottom;

  switch (variant) {
    case variant5:
      // HONDA_SITE_NAME
      // TODO: DSR update for adding Helvetica Neue Medium font
      footerFontFamilyBold = ['bold', 'bold', 'bold'];
      bottomContainerPaddingBottom = ['default', 'default', '40px'];
      bottomContainerPaddingTop = ['zero', 'zero', 'xl'];
      bottomLinksFontFamily = ['default', 'default', 'bold'];
      bottomLinksLineHeight = ['22px', '22px', '18px'];
      bottomMenuGap = 'l';
      bottomMenuListDisplay = ['block', 'block', 'flex'];
      bottomMenuReversed = true;
      copyRightLineHeight = '18px';
      footerWidth = 1040;
      footerWidthPx = `${footerWidth}px`;
      bottomLinksMarginX = ['zero', 'zero', 'xs'];
      locationLabelFontSize = ['16px', '16px', '14px'];
      locationLabelLineHeight = ['26px', '26px', '18px'];
      languageAtSecondary = true;
      locationAtSecondary = true;
      languageLinkFontSize = ['16px', '16px', '14px'];
      locationAtTop = false;
      itemLinkLineHeight = '24px';
      itemLinkFontSize = '14px';
      mainContainerPaddingBottom = [0, 0, 'xl'];
      mainContainerPaddingTop = [0, 0, '40px'];
      mobileBottomLinksAlignment = 'left';
      mobileLanguageAtSecondary = true;
      mobileLocationAtSecondaryUnder = true;
      mobileLocationAtTop = false;
      mobileLocationTwoLines = true;
      mobileMainAccordionBorder = '1px solid';
      mobileMainAccordionBorderColor = 'grey.2';
      mobileMainAccordionIconName = 'animatedArrowUpDown';
      desktopMainBorder = undefined;
      desktopMainBorderColor = undefined;
      mobileSecondaryBorder = ['1px solid', '1px solid', '2px solid'];
      mobileSecondaryBorderColor = 'black';
      mobileSocialAtSecondary = true;
      mobileSocialAtTop = false;
      numberOfFooterColumn = 5;
      secondaryContainerPaddingY = '20px';
      socialMenuAtMain = false;
      socialMenuAtSecondary = true;
      topContainerPaddingB = 'l';
      userLocationContainerMinHeight = '24px';
      userLocationContainerPaddingBottom = 0;
      userLocationContainerWidth = 'unset';
      maxSocialMediaIcons = 4;
      hideMapMarkerIconWhenNoAddressSelected = true;
      footerPaddingTop = 'zero';
      footerColumnsGap = 's';
      footerColumnListMarginBottom = 'xs';
      footerLocationMarginLeft = [0, 0, 'l'];
      addressMarginRight = 'xs';
      addressLineHeight = ['18px', '18px', '24px'];
      footerMobileContainerPaddingX = 'm';
      footerMobileContainerPaddingTop = 'zero';
      footerBottomLinksListItemPaddingY = ['xs', 'xs', 'zero'];
      footerSecondaryMenuContainerPaddingX = 'xs';
      locationLabelMarginBottom = ['xs', 'xs', 'zero'];
      break;

    case variant4:
      // ACURA_SITE_NAME
      footerFontFamily = 'headingRegular';
      footerFontFamilyBold = 'heading';
      bottomContainerPaddingBottom = ['default', 'default', '40px'];
      bottomContainerPaddingTop = ['zero', 'zero', '36px'];
      bottomLinksFontFamily = footerFontFamily;
      bottomLinksFontSize = ['12px', '12px', '14px'];
      bottomLinksLineHeight = ['18px', '18px', '24px'];
      bottomLinksMarginX = ['zero', 'zero', 'm'];
      bottomMenuGap = 'l';
      bottomMenuListDisplay = ['block', 'block', 'flex'];
      bottomMenuReversed = true;
      copyRightLineHeight = ['18px', '18px', 'sm'];
      highlightLangColor = 'tertiaryLight';
      highlightLangFont = 'bold';
      locationLabelFontSize = '14px';
      locationLabelLineHeight = ['22px', '22px', '18px'];
      languageAtSecondary = true;
      languageShowLangCode = true;
      locationAtSecondary = true;
      locationAtTop = false;
      logoAtMain = true;
      languageLinkFontSize = ['16px', '16px', '16px'];
      languageLinkLineHeight = ['20px', '20px', '26px'];
      listHeaderLineHeight = '24px';
      itemLinkLineHeight = '24px';
      itemLinkFontSize = '14px';
      mainContainerPaddingBottom = ['m', 'm', '36px'];
      mainContainerPaddingTop = [0, 0, 'xl'];
      mobileBottomLinksAlignment = 'left';
      mobileContainerStyle = () => ({ borderTop: undefined });
      mobileLanguageAtSecondary = true;
      mobileLocationAtSecondary = true;
      mobileLocationAtTop = false;
      mobileLocationNoMargin = true;
      mobileMainAccordionBorder = 'none';
      mobileMainAccordionBorderColor = undefined;
      mobileMainAccordionHeight = '58px';
      mobileMainAccordionIconName = 'animatedArrowUpDown';
      desktopMainBorder = undefined;
      desktopMainBorderColor = undefined;
      mobileSecondaryBorderColor = 'grey.3';
      mobileSocialAtSecondary = true;
      mobileSocialAtTop = false;
      numberOfFooterColumn = 4;
      secondaryContainerPaddingY = 'default';
      socialMenuAtMain = true;
      socialMediaLinksGapDesktop = '16px';
      topContainerBorderBottom = '1px solid';
      topContainerBorderBottomColor = 'grey.3';
      userLocationContainerMinHeight = '24px';
      userLocationContainerPaddingBottom = 0;
      userLocationContainerWidth = 'unset';
      maxSocialMediaIcons = 4;
      hideMapMarkerIconWhenNoAddressSelected = true;
      footerPaddingTop = 'zero';
      footerColumnsGap = 's';
      footerColumnListMarginBottom = 'xs';
      addressMarginRight = ['m', 'm', 'xs'];
      addressLineHeight = ['22px', '22px', '24px'];
      footerMobileContainerPaddingX = 'm';
      footerMobileContainerPaddingTop = 'zero';
      footerBottomLinksListItemPaddingY = ['xs', 'xs', 'zero'];
      footerSecondaryMenuContainerPaddingX = 'xs';
      break;

    case variant3:
    case variant2:
    case variant1:
    default:
      break;
  }

  return merge(
    {
      variant,
      bottomMenuReversed,
      footerWidth,
      footerWidthPx,
      footerFontFamily,
      footerFontFamilyBold,
      languageAtSecondary,
      languageShowLangCode,
      locationAtSecondary,
      locationAtTop,
      logoAtMain,
      mobileBottomLinksAlignment,
      mobileLanguageAtSecondary,
      mobileLocationAtSecondary,
      mobileLocationAtSecondaryUnder,
      mobileLocationAtTop,
      mobileLocationNoMargin,
      mobileLocationTwoLines,
      mobileMainAccordionIconName,
      mobileSecondaryBorder,
      mobileSecondaryBorderColor,
      mobileSocialAtSecondary,
      mobileSocialAtTop,
      socialMenuAtMain,
      socialMenuAtSecondary,
      socialMediaLinksGapDesktop,
      maxSocialMediaIcons,
      hideMapMarkerIconWhenNoAddressSelected,
      styles: {
        accordionContentContainer: {
          minHeight: mobileMainAccordionHeight,
          borderTop: 'none',
          borderBottom: mobileMainAccordionBorder,
          borderBottomColor: mobileMainAccordionBorderColor,
        },
        copyRight: {
          lineHeight: copyRightLineHeight,
        },
        listHeader: {
          lineHeight: listHeaderLineHeight,
          fontFamily: footerFontFamilyBold,
        },
        locationLabel: {
          fontSize: locationLabelFontSize,
          fontFamily: footerFontFamilyBold,
          lineHeight: locationLabelLineHeight,
          marginBottom: locationLabelMarginBottom,
        },
        locationAddress: {
          lineHeight: addressLineHeight,
          marginRight: addressMarginRight,
        },
        languageLink: {
          fontSize: languageLinkFontSize,
          lineHeight: languageLinkLineHeight,
        },
        highlightLangColor,
        highlightLangFont,
        bottomLinksContainer: {
          ul: {
            display: bottomMenuListDisplay,
          },
          gap: bottomMenuGap,
        },
        itemLink: {
          fontSize: itemLinkFontSize,
          lineHeight: itemLinkLineHeight,
        },
        bottomLinks: {
          fontFamily: bottomLinksFontFamily,
          fontSize: bottomLinksFontSize,
          lineHeight: bottomLinksLineHeight,
          marginX: bottomLinksMarginX,
        },
        topContainer: {
          paddingBottom: topContainerPaddingB,
          borderBottom: topContainerBorderBottom,
          borderBottomColor: topContainerBorderBottomColor,
        },
        topContainerMobile: {
          borderBottom: '1px solid',
          borderBottomColor: 'grey.3',
        },
        mobileContainer: mobileContainerStyle,
        mainContainer: {
          paddingTop: mainContainerPaddingTop,
          paddingBottom: mainContainerPaddingBottom,
          borderBottom: desktopMainBorder,
          borderBottomColor: desktopMainBorderColor,
        },
        secondaryContainer: {
          paddingY: secondaryContainerPaddingY,
          borderTop: mobileSecondaryBorder,
          borderTopColor: mobileSecondaryBorderColor,
          borderBottom: mobileSecondaryBorder,
          borderBottomColor: mobileSecondaryBorderColor,
        },
        bottomContainer: { paddingBottom: bottomContainerPaddingBottom, paddingTop: bottomContainerPaddingTop },
        userLocationContainer: {
          minHeight: userLocationContainerMinHeight,
          paddingBottom: userLocationContainerPaddingBottom,
          width: userLocationContainerWidth,
          flexWrap: mobileLocationTwoLines ? 'wrap' : undefined,
        },
        socialImages: {
          maxHeight: socialImagesMaxHeight,
          maxWidth: socialImagesMaxWidth,
        },
        logo: {
          width: 'auto',
          height: 'auto',
          maxWidth: '124px',
          maxHeight: '100%',
        },
      },
      numberOfFooterColumn,
      footerPaddingTop,
      footerColumnsGap,
      footerColumnListMarginBottom,
      footerLocationMarginLeft,
      footerMobileContainerPaddingX,
      footerMobileContainerPaddingTop,
      footerBottomLinksListItemPaddingY,
      footerSecondaryMenuContainerPaddingX,
    },
    appNameConfig,
  );
};
